import { Routes, Route } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { ThemeProvider } from '@/contexts/ThemeContext'
import Home from '@/pages/Home'
import AdminLogin from '@/pages/AdminLogin'
import Dashboard from '@/pages/Dashboard'
import AdminSetup from '@/components/AdminSetup'

// Exportado para uso no prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/admin/login', element: <AdminLogin /> },
  { path: '/admin/*', element: <Dashboard /> },
]

export default function App() {
  return (
    <ThemeProvider>
      {/* Garante que o perfil admin existe na base de dados */}
      <AdminSetup />

      {/* Toasts globais */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { fontSize: '14px', maxWidth: '380px' },
          success: { iconTheme: { primary: '#26cddc', secondary: '#fff' } },
          error: { iconTheme: { primary: '#268adc', secondary: '#fff' } },
        }}
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        {/*
          /admin/* é gerida pelo Dashboard.
          A protecção real é feita dentro do Dashboard (aguarda isLoading antes de redirecionar)
          e dentro de cada ProtectedRoute nas sub-rotas sensíveis.
        */}
        <Route path="/admin/*" element={<Dashboard />} />
      </Routes>
    </ThemeProvider>
  )
}
